import React from 'react';

const LatestNewsSlideInner = ({windowSmall, title, description, buttonAction, buttonText, caseSlideImg, arrLength, currentSlide, date}) => {
    return (
        <>
            <div className={"caseSlideInner"} style={windowSmall ? {height: "auto", padding:20} : {maxWidth:"100%", padding:30, margin:0, display:"flex", flexDirection:"column"}}>
                <div style={{marginBottom: "10px", fontSize: "13px", color: "#888", fontWeight: 600}}>{date}</div>
                <h1 style={{fontSize:"30px"}}>{title}</h1>
                <p style={{fontSize:"18px"}}>{description}</p>
                <button type={"button"}
                        className={"btn btn-primary btn-sm"}
                        onClick={buttonAction}
                        style={windowSmall ? {
                            backgroundColor: "#352C51",
                            borderColor: "#352C51",
                            fontSize: "14px",
                            marginTop: "16px",
                            alignSelf: "center",
                            width: "100%",
                            borderRadius: "10px",
                            padding: "8px 0",
                        } : {
                            backgroundColor: "#352C51",
                            borderColor: "#352C51",
                            fontSize: "18px",
                            marginTop: "20px",
                            alignSelf: "center",
                            borderRadius: "10px",
                            padding: "10px 120px",
                        }}
                >
                    {buttonText}
                </button>
            </div>
            <div className='sliderImg' style={windowSmall ? {height:"300px"} : {}}>
                <img src={caseSlideImg} alt=""/>
                {arrLength > 1 && <div className='slidesCount flex_align'>{`${currentSlide+1}/${arrLength}`}</div>}
            </div>
        </>
    );
};

export default LatestNewsSlideInner;